export const loadModules = () => {
  const context = require.context('../', true, /^\.\/[^/]+\/((?!stories).)*.tsx$/)
  context.keys().map(context)
}
